import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

const Setting = ({ setSetting }) => {
  const [highlight, setHighlight] = useState(true);
  const [showWidget, setShowWidget] = useState(true);

  useEffect(() => {
    if (!isEmpty(localStorage.getItem("highlight"))) {
      setHighlight(localStorage.getItem("highlight"));
    }
    if (!isEmpty(localStorage.getItem("showWidget"))) {
      setShowWidget(localStorage.getItem("showWidget"));
    }
  }, []);
  return (
    <>
      <div
        data-v-b482ffea
        className="s-popup-mask s-top-0 s-left-0 s-w-full s-h-full s-bg-black/50 s-backdrop-blur-[2px] s-fixed"
        style={{ "-ba2031b0": "300" }}
      />
      <div
        data-v-b482ffea
        className={`s-popup s-bottom-0 s-rounded-t-5px s-px-3px s-bg-pop-title-bg ${
          isMobile ? "s-fixed s-w-full" : "s-sticky s-w-desktop"
        }`}
        style={{ "--ba2031b0": "300" }}
      >
        <div>
          <div className="s-py-12px s-leading-5 s-text-17px s-flex s-items-center s-justify-center s-font-bold s-text-pop-title-text">
            Setting
            <span
              onClick={() => setSetting(false)}
              className="s-icon-close s-text-14px s-absolute s-right-5"
            />
          </div>
          <div className={`s-px-4px s-bg-betSlip-light dark:s-bg-black-800 s-divide-y s-text-global-font-default-light dark:s-text-global-font-default-dark s-rounded-t-5px s-divide-black-300 dark:s-divide-black-900 ${isMobile ? 's-min-h-[68vw]' : 's-min-h-[87.04rem]'}`}>
            <div classame="s-px-10px s-py-14px s-flex s-justify-start s-items-center">
              <span className="s-mr-5 s-w-9/12 s-text-14px">
                Highlight when odds change
              </span>
              <div className="s-btn-switch">
                <input
                  id="seNttingOdds"
                  className="s-btn-switch__tgl s-btn-switch__tgl-ios"
                  type="checkbox"
                  checked={highlight}
                  onClick={() => {
                    setHighlight(!highlight);
                    localStorage.setItem("highlight", !highlight);
                  }}
                />
                <label
                  className="s-p-px s-rounded-full s-w-48px s-h-27px s-btn-switch__tgl-label s-left-1/2"
                  htmlFor="settingOdds"
                />
              </div>
            </div>
            <div className="s-px-10px s-py-14px s-flex s-justify-start s-items-center">
              <span className="s-mr-5 s-w-9/12 s-text-14px">
                Show Events Widget in Full-Markets
              </span>
              <div className="s-btn-switch">
                <input
                  id="settingEventsWidget"
                  className="s-btn-switch__tgl s-btn-switch__tgl-ios"
                  type="checkbox"
                  checked={showWidget}
                  onClick={() => {
                    setShowWidget(!showWidget);
                    localStorage.setItem("showWidget", !showWidget);
                  }}
                />
                <label
                  className="s-p-px s-rounded-full s-w-48px s-h-27px s-btn-switch__tgl-label s-left-1/2"
                  htmlFor="settingEventsWidget"
                />
              </div>
            </div>
          </div>

          <div className="s-px-4px s-bg-betSlip-light dark:s-bg-betSlip-dark">
            <div className="s-px-3px s-py-7px s-flex s-justify-start s-items-center s-border-t s-border-black-300 dark:s-border-black-900">
              <button
                onClick={() => setSetting(false)}
                data-v-bf7df09e
                className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-full s-h-40px s-text-17px s-rounded-5px"
              >
                <div
                  data-v-2f9c23fd
                  data-v-bf7df09e
                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                  style={{ "--0b879273": "0" }}
                >
                  <span
                    data-v-2f9c23fd
                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                    style={{ display: "none" }}
                  />
                  <span
                    data-v-2f9c23fd
                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                    style={{ display: "none" }}
                  />
                </div>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default Setting;
